<template minapp='mpx' xlang='wxml'>
  <view class="es-calendar-month">
    <view class="es-calendar-month__title">{{ title }}</view>
    <view class="es-calendar-month__days">
      <view
        wx:for="{{days}}"
        wx:key="index"
        wx:style="{{activeColor}}"
        class="es-calendar-month__day {{item.isToday && 'is-today'}} {{ item.type && 'is-'+ item.type}}"
        bindtap="onClick(index,$event)"
      >
        <view
          wx:if="{{ type === 'range' && item.type && item.type === 'end' && showPop}}"
          class="popover-calendar-wapper"
        >
          <view class="arrow-calendar"></view>
          <view class="popover-calendar"> {{ nightNum }}晚 </view>
        </view>
        <text wx:if="{{item.topText}}" class="es-calendar-month__topText">{{ item.topText }}</text>
        <text
          wx:if="{{!item.topText && item.holiday}}"
          class="es-calendar-month__topText {{item.holidayType}}"
          >{{ item.holiday }}</text
        >
        <text class="es-calendar-month__text">{{ item.text }}</text>
        <text wx:if="{{item.subText}}" class="es-calendar-month__subText">{{ item.subText }}</text>
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import {
    getFullDate,
    makeArr,
    getMonthEndDay,
    // isToday,
    compare,
    compareMonth,
    getDayByOffset,
    getPrevDay,
    getNextDay,
    formatDate,
    calcDateNum
  } from '@didi/es-mpx-shared'

  const props = {
    type: String,
    firstDay: Number,
    minDate: null,
    maxDate: null,
    currentDate: Array,
    startText: String,
    endText: String,
    color: String,
    isDawn: {
      type: Boolean,
      value: false
    },
    showPop: Boolean,
    calendarHoliday: Array,
    timeZoneDate: {
      type: String,
      value: null
    }
  }

  const watcher = function (option) {
    return Object.keys(props).reduce((watch, key) => {
      watch[key] = function (val, old) {
        this.handlerWatch(val, old)
      }
      return watch
    }, option)
  }

  const isToday = (date, todayDate) => {
    if (!(date instanceof Date)) {
      date = new Date(date)
    }

    date.setHours(0, 0, 0, 0)

    const today = todayDate || Date.now()
    today.setHours(0, 0, 0, 0)

    return today.getTime() === date.getTime()
  }

  const isTomorrow = (date, todayDate) => {
    const tomorrow = new Date(date)
    //console.log('tomorrow', tomorrow);
    tomorrow.setDate(tomorrow.getDate() - 1)
    tomorrow.setHours(0, 0, 0, 0)

    const today = todayDate || Date.now()
    today.setHours(0, 0, 0, 0)

    return today.getTime() === tomorrow.getTime()
  }

  const isLastDay = (date, todayDate) => {
    const lastDay = new Date(date)
    lastDay.setDate(lastDay.getDate() + 1)
    lastDay.setHours(0, 0, 0, 0)

    const today = todayDate || Date.now()
    today.setHours(0, 0, 0, 0)

    return today.getTime() === lastDay.getTime()
  }

  const someTomorrow = (current = [], dawn = false, todayDate) => {
    current = Array.isArray(current) ? current : [current]
    let today = todayDate || Date.now()
    return current.some(
      (date) => (dawn ? isLastDay(date, today) : isTomorrow(date, today)) || isToday(date, today)
    )
  }

  createComponent({
    props: {
      ...props,
      date: {
        type: Number,
        optionalTypes: [String, Date],
        value: Date.now()
      }
    },

    data: {
      days: []
    },

    computed: {
      title() {
        const { year, month } = getFullDate(this.date)
        return `${year}年${month}月`
      },
      activeColor() {
        return {
          backroundColor: this.color
        }
      },
      nightNum() {
        return calcDateNum(this.currentDate[0], this.currentDate[1]) - 1
      },
      holidayMap() {
        let map = {}
        this.calendarHoliday?.map((item) => {
          map[item.date] = item
        })
        return map
      }
    },

    watch: watcher({
      date: {
        immediate: true,
        handler(val, old) {
          this.handlerWatch(val, old)
        }
      }
    }),

    methods: {
      handlerWatch(val, old) {
        if (val === old) {
          return
        }
        this.days = this.getDays()
      },

      getText(type) {
        if (this.type === 'range') {
          if (type === 'start') {
            return this.startText
          }
          if (type === 'end') {
            return this.endText
          }
          if (type === 'start-end') {
            return `${this.startText.substr(0, 1)}/${this.endText.substr(0, 1)}`
          }
        }
        return ''
      },

      getDayType(day) {
        const { type, minDate, maxDate, currentDate } = this

        if (compare(day, minDate) < 0 || compare(day, maxDate) > 0) {
          return 'disabled'
        }

        if (type === 'single') {
          return compare(day, currentDate[0]) === 0 ? 'selected' : ''
        }

        if (type === 'multiple') {
          return this.getMultipleDayType(day)
        }

        if (type === 'range') {
          return this.getRangeDayType(day)
        }

        return ''
      },

      getMultipleDayType(day) {
        const { currentDate } = this
        if (!Array.isArray(currentDate)) {
          return ''
        }

        const isSelected = (date) => currentDate.some((item) => compare(item, date) === 0)

        if (isSelected(day)) {
          const prevDay = getPrevDay(day)
          const nextDay = getNextDay(day)
          const prevSelected = isSelected(prevDay)
          const nextSelected = isSelected(nextDay)

          if (prevSelected && nextSelected) {
            return 'multiple-middle'
          }

          if (prevSelected) {
            return 'end'
          }

          return nextSelected ? 'start' : 'multiple-selected'
        }

        return ''
      },

      getRangeDayType(day) {
        const { currentDate } = this

        if (!Array.isArray(currentDate)) {
          return ''
        }

        const [startDay, endDay] = currentDate

        if (!startDay) {
          return ''
        }

        const compareToStart = compare(day, startDay)

        if (!endDay) {
          return compareToStart === 0 ? 'start' : ''
        }

        const compareToEnd = compare(day, endDay)

        if (compareToStart === 0 && compareToEnd === 0) {
          return 'start-end'
        }

        if (compareToStart === 0) {
          return 'start'
        }

        if (compareToEnd === 0) {
          return 'end'
        }

        if (compareToStart > 0 && compareToEnd < 0) {
          return 'middle'
        }

        return ''
      },

      onClick(index) {
        const { type } = this
        const item = this.days[index]
        if (item.type !== 'disabled') {
          this.$trigger('click', item)
        } else {
          this.$trigger('invalid', item)
        }
      },

      getDays() {
        const { date, maxDate, holidayMap } = this
        const start = new Date(date)
        const { year, month, week } = getFullDate(new Date(start.getFullYear(), start.getMonth(), 1))
        const currentDay = getMonthEndDay(year, month)
        const offset = week < this.firstDay ? 7 - this.firstDay + week : week - this.firstDay
        const total = currentDay + offset
        let holidayText, holidayType
        const timeZoneToday = this.timeZoneDate ? new Date(this.timeZoneDate) : new Date()

        return makeArr(total).map((item, index) => {
          const day = index - offset + 1
          const fullDate = new Date(year, month - 1, day)
          const disabled = compare(this.minDate, fullDate) === 1
          let type = this.getDayType(fullDate)

          const today = isToday(fullDate, timeZoneToday)
          const tomorrow = isTomorrow(fullDate, timeZoneToday)
          const lastDay = isLastDay(fullDate, timeZoneToday)

          if (offset > index) {
            return {
              type: 'disabled',
              date: undefined,
              text: undefined,
              subText: undefined
            }
          }

          if (holidayMap) {
            holidayText = holidayMap[formatDate(fullDate)]
              ? holidayMap[formatDate(fullDate)].text
              : null
            holidayType = holidayText && holidayText === '班' && type === '' ? 'blue-text' : ''
          }

          /**
           * 凌晨入住逻辑：
           * 用户进入app时间为0-6点
           * 当天为可预订的时间
           * 离店时间默认为中午
           */

          let topText = ''
          let subText = ''
          let text = day

          if (this.isDawn) {
            topText = lastDay
              ? '今天凌晨'
              : today
              ? '今天中午'
              : someTomorrow(this.currentDate, true, timeZoneToday)
              ? ''
              : this.getText(type)
            subText =
              lastDay || today
                ? this.getText(type)
                : someTomorrow(this.currentDate, true, timeZoneToday)
                ? this.getText(type)
                : ''
          } else {
            topText = today
              ? '今天'
              : tomorrow
              ? '明天'
              : someTomorrow(this.currentDate, false, timeZoneToday)
              ? ''
              : this.getText(type)
            subText =
              today || tomorrow
                ? this.getText(type)
                : someTomorrow(this.currentDate, false, timeZoneToday)
                ? this.getText(type)
                : ''
          }

          return {
            type,
            isToday: today,
            isTomorrow: tomorrow,
            date: fullDate.getTime(),
            text: this.isDawn && lastDay ? getNextDay(fullDate).getDate() : day,
            topText,
            subText,
            lastDay,
            holiday: holidayText ? holidayText : '',
            holidayType: holidayType ? holidayType : ''
          }
        })
      }
    }
  })
</script>

<style lang="stylus" src='./month.styl' scoped></style>
<script name='json'>
  module.exports = {
    component: true
  }
</script>

